import {
  BusinessProcessType, cvc, ImportBPType, PayloadBPType, PayloadDeleteBPType, PayloadDetailType, PayloadGetProcessType, PayloadGetWlaTemplate,
  PayloadImportProcessBoard,
  PayloadMoveBPType,
  PayloadMutationProcessType,
  PayloadWLASubmitType,
  ResponseMutationProcessType,
  WorkloadStandartType,
} from 'components/types/businessProcess';
import {
  ApqcItem, APQCLibraryType, APQCTemplateType, PayloadAPQCLibraryType, PayloadAPQCTemplateType,
  PayloadAPQCType,
  PayloadAPQCVersionType,
} from 'components/types/businessProcess/apqc';
import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;

export const apiProcess = {
  treeViewList: 'process/tree-view',
  CVCList: 'process/company-value-chain',
  ValueChainList: 'process/value-chain',
  hierarchyList: 'process/hierarchy',
  apqcVersionList: 'process/list-apqc-version',
  apqcVersionList_V2: 'apqc/versions',
  apqcLibraryList: 'process/list-apqc-library',
  apqcLibraryList_V2: 'apqc/libraries',
  apqcTemplateList: 'process/list-apqc-template',
  apqcTemplateList_V2: 'apqc/templates',
  detailProcess: 'process/detail',
  detailProcess_V2: 'process/',
  createProcess: 'process/create',
  createProcess_V2: 'process',
  mutationProcess: 'process/',
  updateProcess: 'process/update',
  deleteProcess: 'process/delete',
  createTreeProcess: 'process/add-tree',
  createTreeProcess_V2: 'process/:process_id/tree',
  createChildProcess: 'process/create-child',
  createChildProcess_V2: 'process/:process_id/children',
  createAPQC: 'process/add-apqc',
  createAPQC_V2: 'process/apqc',
  moveProcess: 'process/move-tree',
  moveProcess_V2: 'process/:process_id/move',
  wlaTemplateList: 'wla-template/list',
  wlaTemplateSubmit: 'wla-template/submit',
  importProcess: 'process/import',
  importProcessBoard: 'process/import-from-another-board',
};

export const processService = {
  getTreeViewList: async (payload: PayloadGetProcessType): Promise<BusinessProcessType[]> => {
    const response = await http.post(`${URL_V2}${apiProcess.treeViewList}`, payload);
    const safeData = Array.isArray(response?.data?.data) ? response?.data?.data : [];

    return safeData;
  },

  getCVCList: async (query: PayloadGetProcessType): Promise<cvc[]> => {
    const response = await http.get(`${URL_V2}${apiProcess.ValueChainList}`, {
      params: query,
    });

    return response.data?.data ?? response.data;
  },

  getHierarchy: async () => {
    const response = await http.post(`${URL}${apiProcess.hierarchyList}`);

    return response.data?.data ?? response.data;
  },

  getApqcVersion: async (query: PayloadAPQCVersionType): Promise<ApqcItem[]> => {
    const response = await http.get(`${URL_V2}${apiProcess.apqcVersionList_V2}`, {
      params: query,
    });

    return response.data?.data ?? response.data;
  },

  getApqcLibrary: async (payload: PayloadAPQCLibraryType): Promise<APQCLibraryType[]> => {
    const response = await http.get(`${URL_V2}${apiProcess.apqcLibraryList_V2}`, {
      params: payload,
    });

    return response.data?.data ?? response.data;
  },

  getApqcTemplate: async (payload: PayloadAPQCTemplateType): Promise<APQCTemplateType[]> => {
    const response = await http.get(`${URL}${apiProcess.apqcTemplateList_V2}`, {
      params: payload,
    });

    return response.data?.data ?? response.data;
  },

  getWlaTemplateList: async (payload: PayloadGetWlaTemplate): Promise<WorkloadStandartType[]> => {
    const response = await http.post(`${URL}${apiProcess.wlaTemplateList}`, payload);

    return response.data?.data ?? response.data;
  },

  detailProcess: async (payload: PayloadDetailType): Promise<BusinessProcessType> => {
    const response = await http.post(`${URL}${apiProcess.detailProcess}`, payload);

    return response.data?.data ?? response.data;
  },

  getProcessDetail: async (payload: PayloadDetailType): Promise<BusinessProcessType> => {
    const { board_id, process_id } = payload;
    const response = await http.get(`${URL}${apiProcess.detailProcess_V2}${process_id}`, {
      params: { board_id },
    });

    return response.data?.data ?? response.data;
  },

  wlaTemplateSubmit: async (payload: PayloadWLASubmitType):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.wlaTemplateSubmit}`, payload);

    return response.data;
  },

  createProcess: async (payload:PayloadMutationProcessType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL_V2}${apiProcess.createProcess_V2}`, payload);

    return response.data;
  },

  createTreeProcess: async (payload:PayloadMutationProcessType):Promise<ResponseMutationProcessType> => {
    const { process_id, ...newPayload } = payload;

    const newEndpoint = apiProcess.createTreeProcess_V2.replace('process_id', process_id);

    const response = await http.post(`${URL_V2}${newEndpoint}`, newPayload);

    return response.data;
  },

  createChildProcess: async (payload: PayloadMutationProcessType): Promise<ResponseMutationProcessType> => {
    const { process_id, ...newPayload } = payload;

    const newEndpoint = apiProcess.createChildProcess_V2.replace('process_id', process_id);

    const response = await http.post(`${URL}${newEndpoint}`, newPayload);

    return response.data;
  },

  updateProcess: async (payload: PayloadMutationProcessType): Promise<ResponseMutationProcessType> => {
    const response = await http.put(`${URL_V2}${apiProcess.mutationProcess}`, payload);

    return response.data;
  },

  deleteProcess: async (payload: PayloadDeleteBPType): Promise<ResponseMutationProcessType> => {
    const { process_id } = payload;
    const response = await http.delete(`${URL_V2}${apiProcess.mutationProcess}${process_id}`);

    return response.data;
  },

  createAPQC: async (payload: PayloadAPQCType): Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL_V2}${apiProcess.createAPQC_V2}`, payload);

    return response.data;
  },

  moveProcess: async (payload:PayloadMoveBPType):Promise<ResponseMutationProcessType> => {
    const { process_id, type } = payload;

    const endpointMove = apiProcess.moveProcess_V2.replace(':process_id', process_id);
    const response = await http.put(`${URL_V2}${endpointMove}`, {
      type,
    });

    return response.data;
  },

  importProcess: async (payload: ImportBPType):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.importProcess}`, payload);

    return response.data;
  },

  importProcessBoard: async (payload: PayloadImportProcessBoard):Promise<ResponseMutationProcessType> => {
    const response = await http.post(`${URL}${apiProcess.importProcessBoard}`, payload);

    return response.data;
  },
};
